module.exports = __webpack_public_path__ + "img/view_scores.6cb2a9ca.png";